

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop, Watch} from "vue-property-decorator";
  import {EServiceProviderType, IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
  import {IErrors} from "@/model/IErrors";
  import V2SpFormCardLayout from "@/components/serviceProvider/v2/layouts/V2SpFormCardLayout.vue";

  @Component({
    components: {V2SpFormCardLayout}
  })
  export default class SPInfoCardInstructionList extends Vue {

    @Prop()
    public provider!: IServiceProvider;
    @Prop()
    public errors!: IErrors;
    @Prop()
    public editing!: boolean;
    @Prop()
    public viewing!: boolean;
    @Prop()
    public submitting!: boolean;

    @Prop({ type: Boolean, default: false })
    public submitted!: boolean;

    public tab: any = null;
    public localViewing: boolean = false;

    public get isInfoCard(): boolean {
      return this.provider.type == EServiceProviderType.infocard || this.provider.type == EServiceProviderType.infocard_sending;
    }

    public get showDetails(): boolean {
      return this.editing || this.viewing || this.localViewing;
    }

    public get localeItems(): string[] {
      return Object.keys(this.provider.about_us);
    }


    public fieldError(locale: string, fieldKey: 'primary_service_description' | 'about_us'): string[] {
      if (!this.submitted) return [];
      const field = this.provider[fieldKey] as Record<string, string>;
      if (!field[locale]) return [this.$t('common.required') as string];
      return [];
    }

    public onExpand() {
      this.localViewing = true;
    }
  }
